document.addEventListener('DOMContentLoaded', function () {
    const components = {
        'product-card': '.passivewp-product-card',
        'image': '.passivewp-image-display',
        'button': '.passivewp-button-display',
        'productvsproduct': '.passivewp-product-comparison-product-card',
        'grid': '.passivewp-grid-item',
        'carousel': '.passivewp-carousel-item',
        'list': '.passivewp-list-item',
    };

    // Generate or retrieve a persistent visitor ID
    function getVisitorId() {
        const storageKey = 'passiveWPVisitorId';
        let visitorId = window.localStorage.getItem(storageKey);

        if (!visitorId) {
            // Generate a new random ID
            visitorId = 'visitor_' + Math.random().toString(36).substr(2, 9);
            window.localStorage.setItem(storageKey, visitorId);
        }

        return visitorId;
    }

    const visitorId = getVisitorId();

    const trackView = async (element, blockType) => {
        const linkId = element.dataset.lid;
        const pageId = passiveWPTracking.pid;
        const nonce = passiveWPTracking.nonce;

        if (!linkId || !pageId || !visitorId) return;

        try {
            await window.wp.apiFetch({
                path: '/passivewp/v1/track-view',
                method: 'POST',
                headers: {
                    'X-WP-Nonce': nonce,
                },
                data: {
                    link_id: linkId,
                    page_id: pageId,
                    block_type: blockType,
                    visitor_id: visitorId,
                },
            });
        } catch (error) {
            console.error('Error tracking view:', error);
        }
    };

    const trackClick = async (element, blockType) => {
        const linkId = element.dataset.lid;
        const pageId = passiveWPTracking.pid;
        const nonce = passiveWPTracking.nonce;

        if (!linkId || !pageId || !visitorId) return;

        try {
            await window.wp.apiFetch({
                path: '/passivewp/v1/track-click',
                method: 'POST',
                headers: {
                    'X-WP-Nonce': nonce,
                },
                data: {
                    link_id: linkId,
                    page_id: pageId,
                    block_type: blockType,
                    visitor_id: visitorId,
                },
            });
        } catch (error) {
            console.error('Error tracking click:', error);
        }
    };

    const handleIntersection = (entries, observer, blockType) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                trackView(entry.target, blockType);
                observer.unobserve(entry.target);
            }
        });
    };

    Object.entries(components).forEach(([blockType, selector]) => {
        const elements = document.querySelectorAll(selector);

        // IntersectionObserver for tracking "view" once element is in the viewport
        const observer = new IntersectionObserver(
            (entries, obs) => handleIntersection(entries, obs, blockType),
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.5,
            }
        );

        elements.forEach((element) => {
            observer.observe(element);

            // Track clicks (left-click and middle-click) on all links in this element
            element.querySelectorAll('a').forEach((link) => {
                // Left-click (also covers mobile taps)
                link.addEventListener('click', () => {
                    trackClick(element, blockType);
                });

                // Middle-click
                link.addEventListener('auxclick', (event) => {
                    if (event.button === 1) {
                        trackClick(element, blockType);
                    }
                });
            });
        });
    });
});
